import React from 'react';
import { MainLayout } from '../../components';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { AddressVerificationProvider, EditableSectionsContext, InsuranceSettings, Loader } from '@uplift/ui-v2';
import { useCurrentuser } from '@uplift/contexts';


const useStyles = makeStyles()((theme) => ({
  container: {
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '769px',
    }
  },
}));


export const InsurancePage: React.VFC = () => {
  const me = useCurrentuser();
  const { classes } = useStyles();
  const [ editKey, setEditKey ] = React.useState(null);

  return (
    <MainLayout>
      <AddressVerificationProvider shouldReverifyAddress={false} parsedVerifiedAddress={null}>
        <EditableSectionsContext.Provider value={{ editKey, setEditKey }}>
          <Box className={classes.container}>
            <Typography variant="h3">Insurance</Typography>
            <Box mt={7} mb={10}>
              <React.Suspense fallback={<Loader color="primary" height="400px" />}>
                <InsuranceSettings userId={me.id} />
              </React.Suspense>
            </Box>
          </Box>
        </EditableSectionsContext.Provider>
      </AddressVerificationProvider>
    </MainLayout>
  );
};
